/**
 * @Description File description.
 * @FileName fasatTextFilter.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 07 July, 2021 03:11:13
 * @IssueID - Issue IDs
 */
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';
import { useTranslation } from 'react-i18next';
import { FasatIcon } from '../../index';
import FasatTextInput from '../../fasatTextInput/fasatTextInput';
import { staticCommonLabelKeys } from '../../../moduleConstants';

const FasatTextInputContainer = styled.div`
  .fasatTextInput {
    margin-top: 8px;
  }
`;
const changeValueTwo = 2;
function FasatTextFilter({ column }) {
  const [t] = useTranslation();
  const { filterValue, setFilter, primaryTopic } = column;
  const [value, setValue] = useState(filterValue);
  const [saveSubscriptionIds, setSaveSubscriptionIds] = useState([]);

  /**
   * Subscribe button Clicl Event from Modal
   */
  useEffect(() => {
    if (primaryTopic && primaryTopic !== '') {
      const subId = PubSub.subscribe(primaryTopic, () => {
        setValue(null);
        setFilter(null);
      });
      const subIds = saveSubscriptionIds;
      subIds.push(subId);
      setSaveSubscriptionIds(subIds);
    }
    return function cleanup() {
      saveSubscriptionIds.forEach((subId) => PubSub.unsubscribe(subId));
    };
  }, []);

  /**
   * column onChange filter
   */
  const onChange = (changeValue) => {
    setValue(changeValue.target.value);
    if (changeValue.target.value.length > changeValueTwo || changeValue.target.value.length < 1) {
      setFilter(changeValue.target.value || undefined);
    }
  };

  return (
    <FasatTextInputContainer>
      <FasatTextInput
        value={value || ''}
        onChange={useCallback((val) => onChange(val), [onChange])}
        placeholder={t(staticCommonLabelKeys.FILTER_LABEL_SEARCH_HELP)}
        icon={<FasatIcon aria-hidden="true" color="none" fill="none" manulifeName="search" width="20px" height="20px" style={{ transform: 'rotate(-90deg)' }} />}
      />
    </FasatTextInputContainer>
  );
}

FasatTextFilter.propTypes = {
  column: PropTypes.shape({
    filterValue: PropTypes.string,
    setFilter: PropTypes.func,
    primaryTopic: PropTypes.string,
  }).isRequired,
};

export default FasatTextFilter;
